import { Redirect, Stack } from "expo-router";
import { ActivityIndicator } from "react-native";

import { CenteredScreen } from "~/components/ui";
import { AppShell } from "~/components/AppShell";
import { usePushRegistration } from "~/features/notifications/push-registration";
import { useAuth } from "~/hooks/useAuth";
import {
  isInitialOnboardingComplete,
  ONBOARDING_PATH,
} from "~/utils/onboarding";

export default function ProtectedLayout() {
  const { session, user, loading } = useAuth();
  usePushRegistration();

  if (loading) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  if (!session?.user) {
    return <Redirect href="/login" />;
  }

  if (!user) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  // Free accounts go straight in; the paywall lives at the point of hitting a
  // plan limit rather than in front of the whole app.
  if (!isInitialOnboardingComplete(user)) {
    return <Redirect href={ONBOARDING_PATH as never} />;
  }

  return (
    <AppShell>
      <Stack screenOptions={{ headerShown: false }} />
    </AppShell>
  );
}
